"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("./components/index"));
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (data) {
    const _ref = data,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$productsServiceD = _ref.productsServiceData,
      productsServiceData = _ref$productsServiceD === void 0 ? [] : _ref$productsServiceD;
    const _React$useState = React.useState(productsServiceData),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      psData = _React$useState2[0],
      setPSData = _React$useState2[1];
    if (!productsServiceData.length) {
      React.useEffect(() => {
        _axios.default.get('/render/api/configsolution/priceTab', {
          params: {
            lang: 'en',
            domains
          }
        }).then(({
          data
        }) => {
          if (!data.code && data.data) {
            setPSData(data.data);
          }
          // console.log('priceTab', data);
        });
      }, []);
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: title
    }, (0, _reportUtil.reportShow)(['show_productService', componentKey, title])), /*#__PURE__*/React.createElement(_index.default, {
      title: title,
      style: {
        backgroundColor: color
      },
      list: psData
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}